var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "btn btn--primary btn--outline",
          on: { click: _vm.open },
        },
        [_vm._v("\n        " + _vm._s(_vm.campaignCta) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.isOpen
        ? _c("portal", { attrs: { to: "modal" } }, [
            _c(
              "div",
              {
                staticClass:
                  "fixed inset-0 z-50 flex flex-col items-center justify-center",
              },
              [
                _c("div", {
                  staticClass: "absolute inset-0 bg-gray-800 opacity-[.64]",
                  on: { click: _vm.close },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "absolute inset-0 w-[90vw] h-[90vw] max-w-[90vh] max-h-[90vh] sm:w-[90vw] sm:h-[73.6363636364vw] sm:max-w-[110vh] sm:max-h-[90vh] md:w-[90vw] md:h-[62.3076923077vw] md:max-w-[130vh] md:max-h-[90vh] bg-gray-300 text-gray-800 m-auto flex",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "p-[20px] sm:p-[40px] flex flex-1 flex-col",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "absolute top-[18px] right-[18px] cursor-pointer select-none text-gray-400 hover:text-gray-800",
                            on: { click: _vm.close },
                          },
                          [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.svg("x")) },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "h3",
                          {
                            staticClass:
                              "text-gray-900 flex-shrink-0 font-bold mb-sm sm:mb-md",
                          },
                          [_vm._v(_vm._s(_vm.campaignTitle))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "relative flex-1 w-full flex" },
                          [
                            _c(
                              "div",
                              { staticClass: "issuu-wrapper" },
                              [_vm._t("default")],
                              2
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }